// SimplePagination.jsx (Card Style)
import React from 'react';
import { 
  Box, 
  IconButton, 
  Typography, 
  Paper,
  Stack 
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const SimplePagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <Paper 
      elevation={1}
      sx={{ 
        display: 'inline-flex', 
        alignItems: 'center',
        p: 1,
        marginTop: 2,
        marginBottom: 2,
        borderRadius: 1,
        float: 'right',
        backgroundColor: 'background.paper'
      }}
    >
      {/* Previous Button */}
      <IconButton 
        onClick={handlePrevious}
        disabled={currentPage === 1}
        size="small"
        sx={{ 
          mr: 1,
          '&.Mui-disabled': {
            color: 'text.disabled',
            opacity: 0.5
          }
        }}
      >
        <ArrowBackIosNewIcon fontSize="small" />
      </IconButton>

      {/* Page Display */}
      <Box sx={{ px: 2, borderLeft: 1, borderRight: 1, borderColor: 'divider' }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          Page <Typography component="span" sx={{ fontWeight: 700 }}>
            {currentPage}
          </Typography> of {totalPages}
        </Typography>
      </Box>

      {/* Next Button */}
      <IconButton 
        onClick={handleNext}
        disabled={currentPage === totalPages}
        size="small"
        sx={{ 
          ml: 1,
          '&.Mui-disabled': {
            color: 'text.disabled',
            opacity: 0.5
          }
        }}
      >
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
    </Paper>
  );
};

export default SimplePagination;